import api from '@/api'
import { appId } from '@/utils/constant'
import { Dialog } from 'vant';
import store from '../store';

// 获取微信API签名参数，使用vuex，以页面URL缓存配置信息
function getWxAPISign() {
  const currentUrl = location.href.split('#')[0];
  const wxApiPage = store.getters.getJsApiDataByPage(currentUrl);
  if (wxApiPage) {
    return Promise.resolve(wxApiPage.config);
  }

  return api.common.getJsApiSign(currentUrl).then(({data}) => {
    if (!data) {
      Dialog.alert({
        message: '获取微信API签名失败'
      })
      return;
    }

    store.commit('setJsApiData', {
      url: currentUrl,
      config: data
    })
    return data;
  });
}
// 配置微信API
// 'updateAppMessageShareData', 'updateTimelineShareData', 'getLocation','scanQRCode', 'chooseImage', 'uploadImage'
function configWx(apiList, callback) {
  getWxAPISign().then((config) => {
    const { nonceStr, signature, timestamp} = config;
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，
      appId, // 必填，公众号的唯一标识
      timestamp, // 必填，生成签名的时间戳
      nonceStr, // 必填，生成签名的随机串
      signature, // 必填，签名
      jsApiList: apiList // 必填，需要使用的JS接口列表
    })
    setTimeout(()=>{
      callback();
    },500)
  });
}

// 配置分享信息
export function configShareInfo({ title, desc, imgUrl, link }) {
  const apiList = ['onMenuShareAppMessage', 'onMenuShareTimeline'];
  configWx(apiList, () => {
    wx.ready(function() {
      //分享给朋友
      // wx.onMenuShareAppMessage({
      //   title, // 分享标题
      //   desc, // 分享描述
      //   link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      //   imgUrl, // 分享图标
      //   success: () => {
          
      //   }
      // })
      wx.updateAppMessageShareData({
        title: title || '这是分享标题',
        desc: desc || '这是分享描述',
        link: link || 'weixin://dl/business/?t=TkgJd6gqOBf',
        imgUrl: imgUrl || '',
        success: function() {
          console.log('分享成功的回调')
        }
      })
      //分享到朋友圈
      wx.onMenuShareTimeline({
        title, // 分享标题
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
        success: () => {
        }
      })
    });
  });
}

// 显示分享按钮
export function showShareMenus() {
  const apiList = ['showMenuItems'];
  // 复制链接，在QQ浏览器打开，发送给朋友，分享到朋友圈，收藏，分享到QQ，分享到QQ空间
  const showMenus = [
    'menuItem:share:appMessage', 'menuItem:share:timeline',
    'menuItem:share:qq', 'menuItem:share:QZone'
  ];
  configWx(apiList, () => {
    wx.ready(function() {
      wx.showMenuItems({
        menuList: showMenus
      });
    });
  });
}

// 隐藏所有非基础按钮
export function hideNonBaseMenu() {
  const apiList = ['hideAllNonBaseMenuItem'];
  configWx(apiList, () => {
    wx.ready(function() {
      wx.hideAllNonBaseMenuItem();
    });
  });
}

// 隐藏分享等按钮
export function hideShareMenus() {
  const apiList = ['hideMenuItems'];
  // 复制链接，在QQ浏览器打开，发送给朋友，分享到朋友圈，收藏，分享到QQ，分享到QQ空间
  const hideMenus = [
    'menuItem:openWithQQBrowser', 'menuItem:openWithSafari',
    'menuItem:share:appMessage', 'menuItem:share:timeline',
    'menuItem:share:qq', 'menuItem:share:QZone'
  ];
  configWx(apiList, () => {
    wx.ready(function() {
      wx.hideMenuItems({
        menuList: hideMenus // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      });
    });
  });
}

// 扫码
export function ViewQRcode(onSuccess, onFail, onComplete) {
  const apiList = ['scanQRCode']
  configWx(apiList, () => {
    wx.ready(function() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          // let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          onSuccess(res);
        },
        fail: function() {
          if (typeof onFail === 'function') {
            onFail();
          }
        },
        complete: () => {
          if (typeof onComplete === 'function') {
            onComplete();
          }
        }
      });
    });
  });
}

// 获取位置
export function getLocation(callback, failFn, options) {
  const apiList = ['getLocation']
  configWx(apiList, () => {
    wx.ready(function() {
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          const latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
          const longitude = res.longitude // 经度，浮点数，范围为180 ~ -180
          console.log('getlocation1', latitude, longitude)
        },
        fail: function() {
          if (typeof failFn === 'function') {
            failFn();
          }
        },
        cancel: function() {
          let cancelFn = () => {};
          if (options && typeof options.cancel === 'function') {
            cancelFn =  options.cancel;
          }
          cancelFn();
        }
      });
    });
  });
}



